import { StaggerItem } from '@/shared/ui/animations';

interface StackedHeaderProps {
  title: string;
  subtitle?: string;
}

export const StackedHeader = ({ title, subtitle }: StackedHeaderProps) => (
  <header className="flex flex-col items-center gap-2 px-6 pt-8 pb-10">
    <StaggerItem index={0}>
      <h1 className="type-display-md text-foreground">{title}</h1>
    </StaggerItem>
    {subtitle && (
      <StaggerItem index={1}>
        <p className="type-body-lg text-foreground-subtle">{subtitle}</p>
      </StaggerItem>
    )}
  </header>
);
